(() => {
  const buttons = document.querySelectorAll('.JSCopyPostLink');
  if (!buttons.length) return;

  const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.readOnly = true;
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';

    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

  buttons.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      const url = btn.dataset.url || window.location.href;

      try {
        await copyToClipboard(url);

        btn.classList.add('stat-blog-post__buttons--is-copied');

        window.setTimeout(() => {
          btn.classList.remove('stat-blog-post__buttons--is-copied');
        }, 10000);
      } catch (err) {
        alert('Nie udało się skopiować linku. Skopiuj ręcznie z paska adresu.');
      }
    });
  });
})();
